import { globalEnvironment } from './global';
import {BELTRAME_COMMON_ENV} from "./commons/dias-beltrame";
import { GLOBAL_CONFIG } from 'src/app/configs/global.config';

export const environment = {
  ...globalEnvironment,
  ...BELTRAME_COMMON_ENV,
  ...GLOBAL_CONFIG,
  REST: 'https://digitalconsulting-api-dev.azure-api.net/diasbeltrame-func/dev',
  admin_tool_url: 'https://gw-dev.cube.rina.org/admin-tool',
  auth: {
    ...globalEnvironment.auth,
    bearerExcludedUrls: [...globalEnvironment.auth.bearerExcludedUrls], // urls of pdf reports
  },
  b2cPolicies: {
    clientId: '75e28389-dd4b-4ccd-84f4-51a904854cde',
    tenantId: 'c7788286-49f4-40db-bf26-fc1c677df787',
    redirectUri: 'https://beltrame-dev.cube.rina.org/',
    redirectCourtesyPageUri: 'https://www.rina.org/',
    postLogoutRedirectUri: 'https://www.rina.org/',
    tenant: 'rinagroupb2cdevl',
    names: {
      signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
      resetPassword: 'B2C_1A_PASSWORDRESET',
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      },
      resetPassword: {
        authority: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com/B2C_1A_PASSWORDRESET',
      },
      editProfile: {
        authority: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      },
    },
    domain: 'https://test-login.rina.org/',
    subdomain: 'rinagroupb2cdevl.onmicrosoft.com',
    authorityDomain: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com',
  },
  localStorageKeyPrefix: 'cube-beltrame-dev',
};
